import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import PublicNav from '../../components/PublicNav';
import PublicFooter from '../../components/PublicFooter';

export default function Welcome() {
  usePageTitle('Welcome');

  return (
    <div className="min-h-screen bg-surface dark:bg-gray-870 text-slate-900 dark:text-gray-100 flex flex-col">
      <PublicNav/>

      <main className="flex-1 flex items-center justify-center w-full">
        <div className="max-w-md mx-auto px-6 py-16 w-full">
          <div className="text-center">
            <h1 className="text-xl sm:text-2xl font-bold leading-tight tracking-tight text-slate-900 dark:text-white">
              Registration <span className="italic text-teal-700 dark:text-teal-400">successful</span>.
            </h1>
          </div>

          <div className="mt-10 rounded-2xl bg-surface/70 dark:bg-gray-870/60 backdrop-blur-sm border border-slate-900/10 dark:border-gray-100/10 p-6 sm:p-8">
            <div className="text-center">
              <CheckCircleIcon className="mx-auto h-16 w-16 text-green-600 dark:text-green-400" aria-hidden="true"/>
              <p className="mt-6 text-sm text-slate-600 dark:text-gray-300">
                Welcome! You have been successfully registered. Please check your email to confirm
                your registration and activate your account.
              </p>
            </div>

            <div className="mt-8 space-y-4">
              <Link
                to="/signin"
                className="flex w-full justify-center items-center rounded-md bg-slate-900 text-white dark:bg-white dark:text-gray-900 px-4 py-2 text-sm font-medium h-10 shadow hover:opacity-90 transition focus:outline-none focus:ring-2 focus:ring-slate-900 dark:focus:ring-white"
              >
                Sign in
              </Link>

              <p className="text-center text-sm text-slate-600 dark:text-gray-400">
                Looking for the API?{' '}
                <a href="https://predico-elia.inesctec.pt/swagger"
                   target="_blank"
                   rel="noopener noreferrer"
                   className="font-semibold text-teal-700 dark:text-teal-400 hover:underline">
                  Swagger documentation
                </a>
              </p>
            </div>
          </div>

          <div className="mt-6 text-center">
            <Link to="/"
                  className="inline-flex items-center gap-1.5 text-sm text-slate-600 dark:text-gray-400 hover:text-slate-900 dark:hover:text-white transition">
              <ArrowLeftIcon className="h-4 w-4"/>
              Back to homepage
            </Link>
          </div>
        </div>
      </main>

      <PublicFooter/>
    </div>
  );
}
